
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 7.25H5a1 1 0 01-1-1V5a1 1 0 011-1h3V2.5H5A2.5 2.5 0 002.5 5v1.25A2.5 2.5 0 005 8.75h6a1 1 0 011 1V11a1 1 0 01-1 1H8v1.5h3a2.5 2.5 0 002.5-2.5V9.75a2.5 2.5 0 00-2.5-2.5zM4.75 10a2.75 2.75 0 102.75 2.75A2.75 2.75 0 004.75 10zm0 4.5a1.75 1.75 0 111.75-1.75 1.75 1.75 0 01-1.75 1.75zm6.5-8.5A2.75 2.75 0 108.5 3.25 2.75 2.75 0 0011.25 6zm0-4.5A1.75 1.75 0 119.5 3.25a1.75 1.75 0 011.75-1.75zm0 2.5a.75.75 0 10-.75-.75.76.76 0 00.75.75z"}})])
          )
        }
      }
    